import { ReactNode } from "react";

type IndustryPillProps = {
  label: string;
  active?: boolean;
  icon?: string | ReactNode;
  onClick?: () => void;
};

export const IndustryPill = ({ label, active = false, icon, onClick }: IndustryPillProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`h-[40px] lg:h-[50px] rounded-full px-[14px] 2xl:px-[18px] flex items-center gap-[8px] whitespace-nowrap font-normal text-[13px] lg:text-[15px] 2xl:text-[16px] transition-all duration-200 ${
        active
          ? "bg-[#3A3A3A] text-white shadow-[0_10px_24px_rgba(0,0,0,0.18)]"
          : "bg-white text-[#222] shadow-[0_4px_16px_rgba(0,0,0,0.04)] hover:bg-[#fafafa]"
      }`}
    >
      {typeof icon === "string" ? (
        <img
          src={icon}
          alt=""
          aria-hidden="true"
          className={`w-[16px] h-[16px] lg:w-[20px] lg:h-[20px] object-contain ${active ? "brightness-0 invert" : ""}`}
        />
      ) : (
        <span className={active ? "[&_*]:brightness-0 [&_*]:invert" : ""} aria-hidden="true">
          {icon}
        </span>
      )}
      {label}
    </button>
  );
};
